import { render } from "./Footer_en_m.vue?vue&type=template&id=c7836e8a&scoped=true"
import script from "./Footer_en_m.vue?vue&type=script&lang=js"
export * from "./Footer_en_m.vue?vue&type=script&lang=js"

import "./Footer_en_m.vue?vue&type=style&index=0&id=c7836e8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c7836e8a"

export default script